/**
 * featured-collection 섹션 그룹핑
 * 같은 data-fc-group 값을 가진 "연속된" .shopify-section 들을
 * 하나의 .fc-group-wrap 컨테이너로 감싸고, 첫 섹션의 설정으로 border 적용.
 *
 * Shopify 섹션은 각자 독립 렌더되어 Liquid로 형제 섹션을 감쌀 수 없으므로
 * 클라이언트에서 DOM 래핑한다.
 */
(function () {
  function num(v) {
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  function buildGroups(scope) {
    var root = scope || document;
    var marked = root.querySelectorAll('[data-fc-group]');
    var done = [];

    marked.forEach(function (el) {
      var key = (el.getAttribute('data-fc-group') || '').trim();
      if (!key) return;

      var section = el.closest('.shopify-section');
      if (!section || done.indexOf(section) !== -1) return;
      // 이미 래핑됨
      if (section.parentElement && section.parentElement.classList.contains('fc-group-wrap')) {
        done.push(section);
        return;
      }

      // 같은 group_key를 "명시한" 연속 .shopify-section만 합류.
      // 키가 다르거나 비어있는 섹션(다른 타입 포함)을 만나면 그룹 종료.
      // → 빈 키 자동 상속 없음. 묶을 섹션마다 동일 group_key 입력 필요.
      var run = [section];
      done.push(section);
      var next = section.nextElementSibling;
      while (next && next.classList && next.classList.contains('shopify-section')) {
        var inner = next.querySelector('[data-fc-group]');
        var k = inner ? (inner.getAttribute('data-fc-group') || '').trim() : '';
        if (k !== key) break;
        run.push(next);
        done.push(next);
        next = next.nextElementSibling;
      }

      var border = el.getAttribute('data-fc-group-border') === 'true';
      // 단일 섹션 + border 없음 → 래핑 의미 없음
      if (run.length < 2 && !border) return;

      var wrap = document.createElement('div');
      wrap.className = 'fc-group-wrap';
      wrap.setAttribute('data-fc-group', key);

      wrap.style.setProperty('--fc-group-padding-pc', num(el.getAttribute('data-fc-pad-pc')) + 'px');
      wrap.style.setProperty('--fc-group-padding-mo', num(el.getAttribute('data-fc-pad-mo')) + 'px');
      wrap.style.setProperty('--fc-group-margin-pc', num(el.getAttribute('data-fc-margin-pc')) + 'px');
      wrap.style.setProperty('--fc-group-margin-mo', num(el.getAttribute('data-fc-margin-mo')) + 'px');
      // 그룹 하단 여백(margin-bottom)은 "마지막" 섹션 설정값으로 적용.
      // 그룹 박스(.fc-group-wrap) 바깥 하단에 붙어 다음 섹션과의 간격이 된다.
      var lastMarked = run[run.length - 1].querySelector('[data-fc-group]') || el;
      wrap.style.setProperty('--fc-group-mb-pc', num(lastMarked.getAttribute('data-fc-mb-pc')) + 'px');
      wrap.style.setProperty('--fc-group-mb-mo', num(lastMarked.getAttribute('data-fc-mb-mo')) + 'px');

      if (border) {
        wrap.classList.add('fc-group-wrap--border');
        wrap.style.setProperty('--fc-group-border-width', num(el.getAttribute('data-fc-border-width')) + 'px');
        wrap.style.setProperty('--fc-group-border-color', el.getAttribute('data-fc-border-color') || 'transparent');
        wrap.style.setProperty('--fc-group-border-radius', num(el.getAttribute('data-fc-border-radius')) + 'px');
      }

      run[0].parentNode.insertBefore(wrap, run[0]);
      run.forEach(function (s) {
        wrap.appendChild(s);
      });
    });
  }

  function init() {
    buildGroups(document);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // 테마 에디터에서 섹션 추가/이동 시 재계산
  document.addEventListener('shopify:section:load', function () {
    buildGroups(document);
  });
  document.addEventListener('shopify:section:reorder', function () {
    buildGroups(document);
  });
})();
